import { render, staticRenderFns } from "./EditGoal.vue?vue&type=template&id=2bba74bc&scoped=true&"
import script from "./EditGoal.vue?vue&type=script&lang=js&"
export * from "./EditGoal.vue?vue&type=script&lang=js&"
import style0 from "./EditGoal.vue?vue&type=style&index=0&id=2bba74bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bba74bc",
  null
  
)

export default component.exports